import { createReducer, on } from "@ngrx/store";
import { LoadingState } from "../../../root-store/api-result.state";
import { ServicePlanActions } from "../actions";
import { initialServicePlanState } from "../projects.state";

export const servicePlanReducer = createReducer(
    initialServicePlanState,
    on(ServicePlanActions.load, state => ({
        ...state,
        callState: LoadingState.loading,
    })),
    on(ServicePlanActions.loadSuccess, (state, { servicePlans }) => ({
        ...state,
        result: servicePlans,
        callState: LoadingState.loaded,
    })),
    on(ServicePlanActions.loadFailure, (state, action) => ({
        ...state,
        callState: action.error,
    }))
);
